import { VideoResult } from "common/video/dto/VideoResult";
import SearchResultList, {
  PageNavigation,
} from "components/common/SearchResultList";
import VideoItem from "./VideoItem";
import { useUnosVideoSearch } from "hooks/unos/video/useUnosVideoSearch";
import { VIDEO_PER_PAGE_MAX } from "constant/video";
import { useEffect, useState } from "react";
import { VideoSearchParams } from "common/api/unos_rad/unos_video";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";
import { QUERY_KEYS } from "constant/react_query";
import { videoSearchFieldsGet } from "common/video/video_search";
import VideoSearchFilters from "components/common/video/VideoSearchFilters";
import { SEARCH_NAMES } from "constant/search";

const VideoList = () => {
  const [searchParams, setSearchParams] = useState<VideoSearchParams>({
    [SEARCH_NAMES.LIMIT]: VIDEO_PER_PAGE_MAX,
    [SEARCH_NAMES.SKIP]: 0,
  });
  const videoListResult = useUnosVideoSearch(searchParams);
  const invalidateQuery = useInvalidateQueryByKeys();
  useEffect(() => {
    invalidateQuery.invalidateQueriesByKeys([QUERY_KEYS.UNOS_VIDEO_SEARCH]);
  }, [searchParams]);

  let results: VideoResult[] = videoListResult ? videoListResult["items"] : [];
  const resTotal: number = videoListResult ? videoListResult["resTotal"] : 0;
  const pageNavigationHandle = (pageNum: number) => {
    const skip = pageNum * VIDEO_PER_PAGE_MAX;
    setSearchParams({ ...searchParams, skip });
  };
  const pageNavigation: PageNavigation = {
    resTotal,
    limit: VIDEO_PER_PAGE_MAX,
    skip: searchParams.skip ?? 0,
    pageNavigationHandle,
  };

  const searchHandle = (formData: any) => {
    const searchVals = videoSearchFieldsGet(formData);

    setSearchParams({
      ...searchParams,
      ...searchVals,
      skip: 0,
    });
  };

  return (
    <div>
      <VideoSearchFilters searchHandle={searchHandle} />
      <SearchResultList<VideoResult>
        renderSingle={(video: VideoResult) => (
          <VideoItem video={video} key={`video${video.id}`} />
        )}
        results={results}
        pageNavigation={pageNavigation}
      />
    </div>
  );
};

export default VideoList;
